var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "mx-0 mb-8 pl-0", attrs: { id: "request-list-skeleton" } },
    [
      _c("v-data-table", {
        staticClass: "mt-6 remove-box-shadow custom-table",
        attrs: {
          headers: _vm.headers,
          "hide-default-footer": "",
          "disable-pagination": "",
          "disable-sort": "",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticStyle: { height: "10px" } }),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(5, function (item) {
                      return [
                        _c(
                          "tr",
                          { key: `row-${item}` },
                          _vm._l(1, function (index) {
                            return _c(
                              "td",
                              { key: `row-${item}-item-${index}` },
                              [
                                _c("v-skeleton-loader", {
                                  staticClass: "w-100",
                                  attrs: { type: "text" },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }